import {Component, Input} from "@angular/core";
import {UntypedFormControl, Validators} from "@angular/forms";
import {FormComponent} from "../form.component";

type Form = {
  reference: string;
}

@Component({
    selector: 'app-subscription-reference-form',
    templateUrl: './subscription-reference-form.component.html',
    styleUrls: [],
    standalone: false
})
export class SubscriptionReferenceFormComponent extends FormComponent<string> {
  @Input() reference?: string = '';
  @Input() referencePlaceholder: string = '';
  @Input() required: boolean = false;

  protected createForm() {
    const req = this.required ? [Validators.required] : []
    this.form = this.fb.group({
      reference: new UntypedFormControl(this.reference, [Validators.pattern(/^[A-Za-z0-9_-]{3,80}$/), ...req]),
    })
  }

  formMapper(form: Form): string {
    return form.reference;
  }
}
